import React from "react";

import img1 from "images/rabar/_CLO1937.jpeg";
import img2 from "images/rabar/_CLO1999.jpeg";

const EventiRabar = () => {
	return (
		<section className="module">
			<div className="container">
				<div className="row">
					<div className="col-sm-2 col-sm-offset-5">
						<div className="alt-module-subtitle">
							<span className="holder-w"></span>
							<h5 className="font-serif">Eventi</h5>
							<span className="holder-w"></span>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<h2 className="module-title font-alt">Scopri cosa Rabar può fare per te</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<div className="row multi-columns-row mb-0">
							<div className="col-sm-6 col-md-6 col-lg-6">
								<div className="content-box">
									<div className="content-box-image">
										<img
											src={img1}
											alt="Tavolo di Rabar con un succo d'arancia e un piatto per la colazione"
											style={{ height: 220, width: "100%", objectFit: "cover" }}
										/>
									</div>
									<h3 className="content-box-title font-serif">Prenota il tuo evento</h3>
									{/* {eventi[0].description} */}
								</div>
							</div>
							<div className="col-sm-6 col-md-6 col-lg-6">
								<div className="content-box">
									<div className="content-box-image">
										<img
											src={img2}
											alt="Aperitivo da Rabar"
											style={{ height: 220, width: "100%", objectFit: "cover" }}
										/>
									</div>
									<h3 className="content-box-title font-serif">Degustazioni esclusive</h3>
									{/* {eventi[1].description} */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default EventiRabar;
